module.exports = {"TXTWCL_Watch_Trailer":{"id":"TXTWCL_Watch_Trailer","defaultMessage":"Watch Trailer","flags":["TRACK"],"track":"Watch Trailer"}}